import config from '@config';
import i18n from '@i18n';

/**
 * Logs a message to the console if debug mode is enabled in the configuration.
 *
 * @param message - The main message to log.
 * @param args - Additional arguments to log.
 */
export const log = (message: string, args: Array<unknown> = []): void => {
	if (config.debug) {
		// Ensure args is always an array
		const safeArgs = Array.isArray(args) ? args : [args];
		console.log(i18n.t('log.prefix'), message, ...safeArgs); // eslint-disable-line no-console
	}
};
